import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {formatDate} from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { ClassificationCModel } from 'src/app/models/ClassificationCModel';
import { CategoryModel } from 'src/app/models/ClassificationModel';
import { ContactsModel } from 'src/app/models/ContactsModel';
import { GovernmentsModel } from 'src/app/models/Masterdata.Model';
import { ClassificationCService } from 'src/app/services/ClassificationCService';
import { ContactsService } from 'src/app/services/ContactsService';
import { masterdataService } from 'src/app/services/MasterdataService';
import swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import { ContactsSearchComponent } from '../contacts-search/contacts-search.component';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {
  concode = '' ;
  conaname = '' ;
  consaklut = '' ;
  conspecial = '' ;
  conclass = '' ;
  conkeyperson = '' ;
  conkeytitel = '' ;
  conarea = 'القاهرة';
  conaddress1 = '' ;
  conaddress2 = '' ;
  contel1 = '' ;
  contel2 = '' ;
  contel3 = '' ;
  conmobile = '' ;
  confax = '' ;
  conemail = '' ;
  conweb = '' ;
  conimage : any ='';
  contype = 'Contacts' ;
  compcode = '1' ;
  modifaieddate = '2024-01-01' ;
  userid = '' ;

  SpcialList : ClassificationCModel[]=[];
  CategoryList : CategoryModel[]=[];
  MasterListGov:GovernmentsModel[]=[];
  myimage :any;
  myimage2 = 'data:image/jpg;base64,'
  imageSrc;
  imageSource: any;
  sellersPermitFile: any;
  sellersPermitString = '';
  wk_Acc_Not = false;
  wk_Acc_Not1 = true;

  constructor(public contactsservice :ContactsService,
    public contacts : ContactsModel,
    public ClassificationCService : ClassificationCService,
    public masterdataService : masterdataService,
    public translate: TranslateService,
    public storage: LocalStorageService,
    private sanitizer: DomSanitizer, 
    private dialogref: MatDialog,) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
    this.LookupClassType();
    this.LookupCatregort();
    this.retriveMasterdataGovLookup();
  //  this.Retrive_Next_Serial();
    this.wk_Acc_Not = false;
    this.wk_Acc_Not1 = true;
    if(this.storage.retrieve('stgPatientCode') != ''){ this.concode = this.storage.retrieve('stgPatientCode');
    this.RetriveContacts();
    };
    if(this.storage.retrieve('stgPatientCode') == ''){this.Retrive_Next_Serial()};
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }

  openDialog(){
    const dialogRef = this.dialogref.open(ContactsSearchComponent,
      {
        data: {
          dataKey: this.contacts
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.concode = result.concode;
        this.RetriveContacts();
        dialogSubmitSubscription.unsubscribe();
      });
  }
  RetriveContacts(){
    this.contactsservice.GetContacts(this.concode,'Contacts', this.storage.retrieve('stgcompcode')).subscribe(
      (data: ContactsModel) => {

        //this.concode = data.concode;
        this.conaname = data.conaname;
        this.consaklut = data.consaklut;
        this.conspecial        =data.conspecial
        this.conclass=data.conclass
        this.conkeyperson=data.conkeyperson
        this.conkeytitel=data.conkeytitel
        this.conarea=data.conarea
        this.conaddress1=data.conaddress1
        this.conaddress2=data.conaddress2
        this.contel1=data.contel1
        this.contel2=data.contel2
        this.contel3=data.contel3
        this.conmobile=data.conmobile
        this.confax=data.confax
        this.conemail=data.conemail
        this.conweb=data.conweb
       ///******* */ this.conimage=data.conimage
        this.myimage = data.conimage;
        this.sellersPermitString =  data.conimage;
        this.myimage =this.sellersPermitString;
        var kk = this.sellersPermitString;

        this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
        if(data.conimage =='' || data.conimage == null)
          {
            this.wk_Acc_Not = false;
            this.wk_Acc_Not1 = true;
          }
          else
          {
            this.wk_Acc_Not = true;
            this.wk_Acc_Not1 = false;
          }

    ///***********  */
        this.contype=data.contype
        this.userid = data.userid;
        this.modifaieddate = data.modifaieddate;

      }
    );
  }
  LookupClassType(){
    this.ClassificationCService
    .getClassificationCLookupTop(this.storage.retrieve('stgcompCode'))
    .subscribe((data: ClassificationCModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.SpcialList[i] = data[i];
      }

    });
  }
  LookupCatregort(){
    this.ClassificationCService
    .getCategoryLookupTop()
    .subscribe((data: CategoryModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.CategoryList[i] = data[i];
      }

    });
  }
  retriveMasterdataGovLookup() {
    this.masterdataService
      .getmasterLookupTopGovernments()
      .subscribe((data: GovernmentsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.MasterListGov[i] = data[i];
        }

      });
  }
  submitContacts(){
    this.contacts.concode = this.concode;
    this.contacts.conaname = this.conaname;
    this.contacts.consaklut = this.consaklut;
    this.contacts.conspecial        =this.conspecial
    this.contacts.conclass=this.conclass
    this.contacts.conkeyperson=this.conkeyperson
    this.contacts.conkeytitel=this.conkeytitel
    this.contacts.conarea=this.conarea
    this.contacts.conaddress1=this.conaddress1
    this.contacts.conaddress2=this.conaddress2
    this.contacts.contel1=this.contel1
    this.contacts.contel2=this.contel2
    this.contacts.contel3=this.contel3
    this.contacts.conmobile=this.conmobile
    this.contacts.confax=this.confax
    this.contacts.conemail=this.conemail
    this.contacts.conweb=this.conweb
    this.contacts.conimage = this.sellersPermitString;
    this.contacts.contype='Contacts'
    this.contacts.userid = this.userid;
    this.contacts.modifaieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.contacts.userid = this.storage.retrieve('stguserId');




    this.contactsservice.AddContacts(this.contacts).subscribe(data => {

      this.mesgSave();
      this.NewData();
    },

      error => { alert(error); }

    );
  }
  MesgDelete(){}
  NewData(){
    this.storage.store('stgPatientCode', '');
  this.concode = '' ;
  this.conaname = '' ;
  this.consaklut = '' ;
  this.conspecial = '' ;
  this.conclass = '' ;
  this.conkeyperson = '' ;
  this.conkeytitel = '' ;
  this.conarea = 'القاهرة';
  this.conaddress1 = '' ;
  this.conaddress2 = '' ;
  this.contel1 = '' ;
  this.contel2 = '' ;
  this.contel3 = '' ;
  this.conmobile = '' ;
  this.confax = '' ;
  this.conemail = '' ;
  this.conweb = '' ;
  this.myimage ='';
  this.conimage ='' ;
  this.contype = 'Contacts' ;
  this.wk_Acc_Not = false;
    this.wk_Acc_Not1 = true;
  this.Retrive_Next_Serial();

  }
  mesgSave() {
    swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }
  public picked(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.sellersPermitFile = file;

      this.handleInputChange(file); //turn into base64

    }
    else {
      alert("No file selected");
    }
  }
  handleInputChange(files: any) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e: any) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.sellersPermitString = base64result;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);

    console.log("imageSource ## :" + this.imageSource);
  }
  Retrive_Next_Serial(){
    this.contactsservice.GetNextSerial().subscribe(
      (data: ContactsModel) => {

        this.concode = data.concode;

      }
    );
  }

}
